import React, { useEffect, useState, useRef, useMemo, useContext } from "react";
import axios from "axios";
import Select from "react-select";
import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import ReportDate from "../../../components/Reports/ReportDate";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";
import moment from "moment";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import Reportcurrencysymbols from "../../../common/Reportcurrencysymbols";

const PaymentSummaryReport = (props) => {
  const token = localStorage.getItem("Token");
  const locationid = localStorage.getItem("Location");
  const {
    CurrencySymbol,
    FractionDigits,
    ReportViewPermission,
    currencySymbolLocation,
  } = useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [nemultiselect, setnemultiselect] = useState({
    PaymentType: [],
  });
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });
  const [employeeid, setemployeeid] = useState(0);
  const [saletype, setSaletype] = useState([]);
  const [employeeDropdown, setemployeeDropdown] = useState([]);
  const [salesTypeValue, setSalesTypeValue] = useState();
  const [salesTypeID, setSalesTypeID] = useState(0);
  const [classicView, setClassicView] = useState(true);

  const ITEMS_PER_PAGE = 10;

  const [totalData, setTotalData] = useState({
    PaymentAmountsum: 0,
  });

  let dashStyle = {
    // width: "280px",
    background: "#fff",
    marginTop: "10px",
    borderRadius: "6px",
    padding: "20px",
    border: "1px solid #E8EBED",
    width: "22%",
  };

  const handleDropdownChange = (event) => {
    console.log(event, "event123");
    setSelectReport(event?.value);
    if (event?.value === 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const paramObject = useParams();

  console.log(responseData, "responseData127");
  let salesTypeDropdownOption = [];
  const SalesTypeDropdown = saletype
    .filter((e) => e.ID != 3)
    .map((u, i) => {
      salesTypeDropdownOption[i] = { label: u.SalesType, value: u.ID };
    });

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        setLoading(false);
        return res;
      });

    axios
      .get(`${config.salesconfigBaseUrl}/sales/saletype`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        setSaletype(response.data.ResponseData);
        console.log(response.data.ResponseData, "===> setSaletype");
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(`${config.reportsBaseUrl}/reports/employeedropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        // console.log("employee", res);
        setemployeeDropdown(res.data.ResponseData);
        // setLoading(false);

        return res;
      });
  }, []);

  const RolesDropdown = (event, index) => {
    console.log(event?.label, event?.value, event?.id, "RolesDropdown");
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);
  };

  const Classiccolumns = [
    {
      title: "Payment Type",
      field: "PaymentType",
      headerFilter: "input",
      defaultVisible: true,
      frozen: true,
    },
    {
      title: "Payment Amount",
      field: "PaymentAmount",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    // {
    //   title: "Modified By",
    //   field: "ModifiedBy",
    //   headerMenu: headerMenu,
    //   headerFilter: "input",
    //   defaultVisible: true,
    // },
  ];

  const columns = useMemo(() => [
    {
      header: "Payment Type",
      accessorKey: "PaymentType",
      filterSelectOptions: nemultiselect?.PaymentType, // ["paid", "unpaid"],
      filterVariant: "multi-select", //"select",
      enableColumnFilterModes: false,
    },
    {
      header: "Payment Amount",
      accessorKey: "PaymentAmount",
      muiTableBodyCellProps: { align: "right" },
      Cell: ({ row }) => {
        const PaymentAmount = row?.original?.PaymentAmount;
        if (PaymentAmount == "0.00" || PaymentAmount == "") {
          return "";
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(PaymentAmount),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
  ]);

  const handleChangeSalesType = (event) => {
    setSalesTypeValue(event);
    setSalesTypeID(event?.value);
  };

  const handleChangeEmployee = (event) => {
    setemployeeid(event?.value);
  };

  const apicall = () => {
    setLoading(true);
    setResponseData([]);
    setTotalData({ PaymentAmountsum: 0 });
    axios
      .get(
        `${config.reportsBaseUrl}/reports/paymentsummaryreport?filtercolumnsearchtext=&currentorder=&ordercolumn=0&pagesize=0&pagenumber=0&filtertext=&startdate=${startdate}&enddate=${enddate}&employeeid=${employeeid}&saletype=${salesTypeID}&locationid=${locationid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          const FilterData = res.data.ResponseData?.map((el) => ({
            ...el,
            PaymentAmount: Number(el.PaymentAmount) || 0,
          }));

          setResponseData(FilterData);
          setTotalData({
            ...totalData,
            PaymentAmountsum: FilterData.reduce(
              (sum, item) => sum + (parseFloat(item.PaymentAmount) || 0),
              0
            ),
          });
        } else {
          setTotalData({
            ...totalData,
            PaymentAmountsum: 0,
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        return;
      });
  };

  // useEffect(() => {
  //   const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";
  //   console.log(
  //     JSON.stringify(columnFilters) + " columnFilters | ",
  //     globalFilter + " globalFilter | ",
  //     pagination.pageIndex + " pagination.pageIndex | ",
  //     pagination.pageSize + " pagination.pageSize | ",
  //     columnIndex,
  //     sorting[0]?.id,
  //     sorting[0]?.desc === undefined
  //       ? "desc"
  //       : (sorting[0]?.desc === true ? "desc" : "asc") + " sorting | ",
  //     startdate + " startdate | ",
  //     enddate + " enddate",
  //     employeeid + " employeeid",
  //     salesTypeID + " saletype",
  //     "api Call payload"
  //   );

  //   const FilterColumnText = {};
  //   FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
  //     return { columnname: el.id, value: el.value, id: index + 1 };
  //   });

  //   let FilterColumnSearchText = JSON.stringify(FilterColumnText);

  //   axios
  //     .get(
  //       `${
  //         config.reportsBaseUrl
  //       }/reports/paymentsummaryreport?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
  //         sorting[0]?.desc === undefined
  //           ? "desc"
  //           : sorting[0]?.desc === true
  //           ? "desc"
  //           : "asc"
  //       }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
  //         pagination.pageSize
  //       }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
  //         globalFilter === undefined ? "" : globalFilter
  //       }&startdate=${startdate}&enddate=${enddate}&employeeid=${employeeid}&saletype=${salesTypeID}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       console.log("res======>", res);
  //       console.log(res.data.ResponseData, "res======>");
  //       if (res.data.ResponseCode === "SUCCESS") {
  //         const FilterData = res.data.ResponseData?.map((el) => ({
  //           ...el,
  //           PaymentAmount: Number(el.PaymentAmount),
  //         }));

  //         const data = res.data.ResponseData;
  //         setResponseData(data);
  //         setRowCount(res.data.ResponseData[0].TotalRecord);
  //         setTotalData({
  //           ...totalData,
  //           PaymentAmountsum: res.data.ResponseData[0].PaymentAmountsum,
  //         });
  //       } else {
  //         setRowCount(0);
  //         setTotalData({
  //           ...totalData,
  //           PaymentAmountsum: 0,
  //         });
  //       }
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       setIsError(true);
  //       console.log(err);
  //       setLoading(false);
  //       return;
  //     });

  //   setIsError(false);
  //   setIsLoading(false);
  //   setIsRefetching(false);
  // }, [
  //   columnFilters,
  //   globalFilter,
  //   pagination.pageIndex,
  //   pagination.pageSize,
  //   sorting,
  //   startdate,
  //   enddate,
  //   employeeid,
  //   salesTypeID,
  // ]);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Payment Summary Report
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-2">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-5">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}

            {/* <div className="col-sm-2">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Sale Type
              </label>
              <div className="row">
                <div className="col-md-12 z-4">
                  <Select
                    defaultValue={salesTypeValue}
                    onChange={(event) => {
                      handleChangeSalesType(event);
                    }}
                    options={salesTypeDropdownOption}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select mt-1"
                  />
                </div>
              </div>
            </div> */}

            {/* <div className="col-sm-3">
              <label className="col-form-label col-md-3">Employee</label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    options={employeeDropdown.map((employee) => ({
                      label: employee.Name,
                      value: employee.Id,
                    }))}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    onChange={(e, index) => handleChangeEmployee(e, index)}
                    className="custom-select-search"
                  />
                </div>
              </div>
            </div> */}
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>
          {responseData.length > 0 && (
            <>
              <div
                className="row"
                style={{
                  display: "grid",
                  gap: "1rem",
                  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                }}
              >
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {CurrencySymbols(
                          Number(totalData.PaymentAmountsum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Total</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card mt-3" id="print">
                <div className="card-body">
                  <div className="container">
                    <div className="col-md-12 text-center" id="header">
                      <h6 className="P">Sonar Pos</h6>
                      <p className="fw-bold p-regular">
                        Payment Summary Report
                      </p>
                      <div className="row">
                        <p>
                          Date:{" "}
                          {startdate === "" && enddate === ""
                            ? "All Data"
                            : moment(startdate).format("MM/DD/YYYY") +
                              " - " +
                              moment(enddate).format("MM/DD/YYYY")}
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div>
                    {ReportViewPermission == true ? (
                      <button
                        className="btn btn-secondary"
                        onClick={() => setClassicView(!classicView)}
                      >
                        {" "}
                        {classicView ? "Classic View" : "Morden View"}
                      </button>
                    ) : (
                      <></>
                    )}
                    {classicView ? (
                      <CommonTabular
                        Data={responseData}
                        columns={Classiccolumns}
                        Groupvalue={[]}
                        Reportname={"Payment Summary Report"}
                        frozenRowvalue={0}
                        // layout={"fitDataFill"}
                        Onrefresh={() => apicall()}
                      />
                    ) : (
                      <CommonMatrialReactTable
                        MainHeading="Sonar POS"
                        ReportHeading="Payment Summary Report"
                        columns={columns}
                        data={responseData}
                        startdate={startdate}
                        enddate={enddate}
                        columnGrouping={[]}
                        columnsVisibility={{}}
                        enableRowSelection={false}
                      />
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default PaymentSummaryReport;
